import { render } from "./FrameTabs.vue?vue&type=template&id=fb950320&scoped=true"
import script from "./FrameTabs.vue?vue&type=script&lang=js"
export * from "./FrameTabs.vue?vue&type=script&lang=js"

import "./FrameTabs.vue?vue&type=style&index=0&id=fb950320&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb950320"]])

export default __exports__